import { SystemVersion } from './system-version.model';


export class SystemVersionHeader {
    definitionName: string;
    id: number;
    elements: SystemVersion[];
}
